import axios from 'axios';
import moment from 'moment';
import loader from '../assets/loading.gif';

const settings = window.APP_SETTINGS;

export const downloadBlob = async (url, onDownloadProgress) => {
  return await axios.get(url, { responseType: 'blob', onDownloadProgress });
};

// Get Order File URL
export const getOrderFileUrl = async (orderId, orderFileId) => {
  try {
    const response = await axios.get(
      `${settings.EXPERT_API_BASE_URL}/orders/${orderId}/files/${orderFileId}/url`
    );
    return response.data;
  } catch (error) {
    console.error('Error getting order file URL:', error);
    throw error;
  }
};

// Get Record File URL
export const getRecordFileUrl = async (orderId, orderRecordId, recordFileId) => {
  try {
    const response = await axios.get(
      `${settings.EXPERT_API_BASE_URL}/orders/${orderId}/order-records/${orderRecordId}/files/${recordFileId}/url`
    );
    return response.data;
  } catch (error) {
    console.error('Error getting record file URL:', error);
    throw error;
  }
};

// View PDF in new tab
export const viewPdfInNewTab = async (url, setIsViewingFile, fileName = null) => {
  try {
    setIsViewingFile(true);
    let newWin = window.open("", "_blank");
    newWin.document.body.background = loader;
    newWin.document.body.style.backgroundRepeat = "no-repeat";
    newWin.document.body.style.backgroundPosition = "center";
    
    newWin.location.href = `/pdf-viewer?pdf=${encodeURIComponent(url)}`;
    
    if (fileName) {
      newWin.document.title = fileName;
    }
    
    setIsViewingFile(false);
    return newWin;
  } catch (err) {
    setIsViewingFile(false);
    console.error('Error viewing PDF:', err);
    throw err;
  }
};

// Download file directly
export const downloadFile = async (
  url, 
  fileName = null, 
  inProgress = false, 
  setInprogress = null, 
  setVariant = null, 
  setCompleted = null, 
  row = null, 
  lastReviewedProp = null, 
  setRow = null
) => {
  if (inProgress) return;
  
  if (setInprogress) setInprogress(true);
  const orgLastReviewedValue = row && lastReviewedProp ? row[lastReviewedProp] : null;
  
  try {
    const downloadRes = await downloadBlob(url, (e) => {
      if (setVariant && setCompleted) {
          setVariant('determinate');
          setCompleted(Math.floor((e.loaded / e.total) * 100));
        }
      }
    );
    
    if (setVariant && setCompleted) {
      setVariant('indeterminate');
      setCompleted(0);
    }
    
    const filename = fileName || downloadRes.headers['x-file-name'];
    
    const blob = new Blob([downloadRes?.data], { type: 'application/octet-stream' });
    download(blob, filename);
    
    if (row && lastReviewedProp && setRow) {
      row[lastReviewedProp] = moment();
      setRow(row);
    }
    
    if (setInprogress) setInprogress(false);
  } catch (error) {
    if (row && lastReviewedProp && setRow && orgLastReviewedValue !== null) {
      row[lastReviewedProp] = orgLastReviewedValue;
      setRow(row);
    }
    
    if (setInprogress) setInprogress(false);
    console.error('Error downloading file:', error);
    throw error;
  }
};

const download = (blob, filename) => {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
